/**
 * Messages from Bot to show in ChatWidget
 */
class BotMessage {
    constructor({
        name = '',
        actionId = 0,
        actionType = 0,
        ts = '',
        msgId = 0,
        msg = '',
        responses = [],
        profile_url = '',
        profile_color = '',
        isError = false
    }) {
        this.role = 'bot';
        this.name = name;
        this.actionId = Number(actionId);
        this.actionType = Number(actionType);
        this.msgId = Number(msgId);
        this.msg = msg;
        this.responses = responses;
        this.profile_url = profile_url;
        this.profile_color = profile_color;
        this.isError = !!isError;

        this.ts = ts;
        if (this.ts === '') {
            this.ts = new Date().toISOString();
        }
    }
}

export default BotMessage;
